import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  COURSE_PAUSE_REQUEST_UPDATE_DURATION_OPTIONS,
  setUpdateDurationMonthsBy,
  updateDurationMonthsBySelector,
} from 'features/courseResume';
import Field from 'components/Field';
import Select from 'components/Select';
import styles from './UpdateDurationByMonthsField.module.scss';

function UpdateDurationByMonthsField() {
  const dispatch = useDispatch();
  const updateDuration = useSelector(updateDurationMonthsBySelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handleDurationChange = useCallback(
    (option) => {
      dispatch(setUpdateDurationMonthsBy(option));
    },
    [dispatch]
  );

  return (
    <Field
      label="Select duration"
      labelClassName="h4 normal"
      className={classNames('m-b-m')}
    >
      <Select
        styles={_styles}
        options={COURSE_PAUSE_REQUEST_UPDATE_DURATION_OPTIONS}
        className={styles.select}
        value={updateDuration}
        onChange={handleDurationChange}
      />
    </Field>
  );
}

export default UpdateDurationByMonthsField;
